import { ModalConfirmation, ModalConfirmationProps, useModal, withModalConditionalRender } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDeleteContactPerson } from '../../hooks/useDeleteContactPerson'

interface DeleteContactPersonModalProps extends ModalConfirmationProps {
  contactPersonId: string
}

const DeleteContactPersonModalComponent = ({ contactPersonId, ...modalProps }: DeleteContactPersonModalProps) => {
  const { t } = useTranslation()
  const { close } = useModal(modalProps.id)
  const { deleteContactPerson, isProcessing } = useDeleteContactPerson()

  const handleConfirmClick = useCallback(() => {
    deleteContactPerson(contactPersonId, { onSuccess: close })
  }, [close, contactPersonId, deleteContactPerson])

  return (
    <ModalConfirmation
      {...modalProps}
      cancelLabel={t('cancel')}
      danger
      message={t('contact.detail.contact_persons.delete_modal.message')}
      okLabel={t('contact.detail.contact_persons.delete_modal.confirm')}
      okLoading={isProcessing}
      onOk={handleConfirmClick}
      title={t('contact.detail.contact_persons.delete_modal.title')}
    />
  )
}

export const DeleteContactPersonModal = withModalConditionalRender(DeleteContactPersonModalComponent)
